import { render } from "./Insurance.vue?vue&type=template&id=f4b2aea6&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"

import "./Insurance.vue?vue&type=style&index=0&id=f4b2aea6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b2aea6"]])

export default __exports__